// extracted by mini-css-extract-plugin
export default {"arrowsContainer":"transfer-arrows_arrowsContainer__Labqd","arrowButton":"transfer-arrows_arrowButton__VoJ-N","decorativeLine":"transfer-arrows_decorativeLine__ja3wc"};